import { useEffect } from 'react';

const useLifetime = (
  enable: boolean,
  out?: { id: string, time: number },
  notify?: number,
  handleNotify?: () => void,
  handleAction?: () => void,
) => {
  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (!enable || !out || !notify || out.time < notify) {
      return () => {
        clearInterval(interval);
      };
    }
    // const stepCount = (out.time - notify) / 2;
    let last = 0;

    interval = setInterval(() => {
      const newVal = last + 5000;
      if (newVal >= out.time) {
        handleAction?.();

        last = 0;
      } else if (newVal >= notify) {
        handleNotify?.();
        last = newVal;
      } else {
        last = newVal;
      }
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  }, [enable, out, notify, handleAction, handleNotify]);
};

export default useLifetime;
